import React from 'react';

// @mui
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Alert
} from '@mui/material';
import i18n from '../../i18n';
import { LoadingButton } from '@mui/lab';

export default class ConfirmDialog extends React.Component {
    onCancel = () => {};
    onConfirm = () => {};

    constructor(props) {
        super(props);

        this.state = {
            dialogOpen: props.dialogOpen || false,
            alertText: props.alertText,
            alertTitle: props.alertTitle,
            error: props.error || false,
            errorText: props.errorText || '',
            loading: false
        };

        this.onCancel = props.onCancel;
        this.onConfirm = props.onConfirm;
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dialogOpen !== state.dialogOpen || props.error !== state.error) {
            return {
                dialogOpen: props.dialogOpen,
                alertText: props.alertText,
                alertTitle: props.alertTitle,
                error: props.error || false,
                errorText: props.errorText || ''
            };
        }

        return null;
    }

    handleDialogCancel = (event, name) => {
        this.onCancel();
    };

    handleDialogConfirm = async (event, name) => {
        this.setState({ loading: true });
        await this.onConfirm();
        this.setState({ loading: false });
    };

    handleDialogClose = (event, name) => {
        this.onCancel();
    };

    render() {
        const { error, errorText, alertText } = this.state;
        return (
            <Dialog
                open={this.state.dialogOpen}
                onClose={this.handleDialogCancel}
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'center' }}>
                    {this.state.alertTitle}
                </DialogTitle>
                <DialogContent>
                    <Alert key="alert" severity={error ? 'error' : 'warning'}>
                        {error ? errorText : alertText}
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(event) => this.handleDialogCancel(event)}>
                        {i18n.t('buttons.cancel')}
                    </Button>
                    {!error && (
                        <LoadingButton
                            loading={this.state.loading}
                            onClick={(event) => this.handleDialogConfirm(event)}
                        >
                            {i18n.t('buttons.confirm')}
                        </LoadingButton>
                    )}
                </DialogActions>
            </Dialog>
        );
    }
}
